<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <!--<div class="wrap">-->
        <!--<div class="ql-editor" v-html="content"></div>-->
      <!--</div>-->
      <!--<div class="wrap">-->
        <!--<img src="@/assets/images/MuseumAffairs06@2x.png" alt="">-->
        <!--<div class="ql-editor">-->
          <!--<p class="ql-align-justify">举重是我国的优势体育项目，新中国成立后，我国举重竞技水平不断提高，进入了世界先进行列。截至2023年12月，中国举重健儿已先后收获39枚奥运会金牌、588枚世锦赛金牌，创破各层次世界纪录超1000次，占世界各国或地区创造世界纪录总数的五分之一。为弘扬中国举重精神，由国家体育总局举重摔跤柔道运动管理中心、中国举重协会和东莞市人民政府三方共建的我国唯一一座全面展示中国举重运动发展及辉煌成就的国家级专题博物馆——中国举重博物馆，在2024年落成启用。</p>-->
          <!--<p class="ql-align-justify">&nbsp;</p>-->
          <!--<p class="ql-align-justify">中国举重博物馆，坐落于曾哺育出新中国第一个打破世界纪录的陈镜开、夺得第一枚奥运举重金牌的曾国强等一大批享誉世界举坛运动员的著名“举重之乡”——东莞石龙。场馆以新旧融合为设计理念，主体建筑既有新建馆体，亦完整保留70年代石龙老体校。场馆总建筑面积14000余平方米，馆藏品6000余件，馆内通过图文、实物展示以及沉浸式互动体验等方式，展示中国举重运动发展、传播中国举重文化、弘扬举重精神，是促进中外体育交流的重要平台和窗口。 </p>-->
          <!--<img src="@/assets/images/MuseumAffairs05@2x.png" alt="">-->
        <!--</div>-->
      <!--</div>-->
      <div class="wrap">
        <table v-if="$store.getters.lang=='en'">
          <tr>
            <td style="width: 104px;display: flex;">2011：</td>
            <td>On October 12, the Chinese Weightlifting Association agreed to Shilong Town people's Government's request to build a weightlifting museum</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2020：</td>
            <td>On November 2, Yang Xiaotang, then a member of the Standing Committee of the Dongguan Municipal Committee, led a team to Beijing to report to Zhou Jinqiang, then director of the Lifting and Wrestling Center of the State General Administration of Sport, on the preparation of the weightlifting museum</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2021：</td>
            <td>On March 1, the weightlifting Museum was officially started<br/>
              On September 8, Xue Lian, vice president of the China Weightlifting Association, led a team to inspect and guide the construction of the weightlifting Museum, and handed over a batch of weightlifting trophies and materials collected by the association to the permanent collection of the Weightlifting Museum.</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2022：</td>
            <td>On July 20, the Lifting and Wrestling Center of the State General Administration of Sport and the Chinese Weightlifting Association agreed to build a weightlifting museum in Shilong, Dongguan.</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2023：</td>
            <td>
              In June, the main project of the Weightlifting Museum was completed<br/>
              On November 7, the State General Administration of Sport, the Lifting and soft Sports Management Center, the Chinese Weightlifting Association and the Dongguan City People's Government jointly signed the Framework Agreement on the cooperation and co-construction of the China Weightlifting Museum to do a good job in the preparation, management and operation of the weightlifting museum and improve the level of weightlifting training in Shilong Town.
            </td>
          </tr>
        </table>
        <table v-else>
          <tr>
            <td style="width: 104px;display: flex;">2011年：</td>
            <td>10月12日，中国举重协会同意石龙镇人民政府筹建举重博物馆的请示</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2020年：</td>
            <td>11月2日，时任东莞市委常委杨晓棠带队到北京向时任国家体育总局举摔柔中心主任周进强汇报举重博物馆筹建工作</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2021年：</td>
            <td>3月1日，举重博物馆正式动工<br/>
                9月8日，中国举重协会副主席薛炼带队考察指导举重博物馆建设工作，并把协会珍藏的一批举重运动奖杯和资料移交给举重博物馆永久收藏。</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2022年：</td>
            <td>7月20日，国家体育总局举摔柔运动中心和中国举重协会同意在东莞石龙共建举重博物馆。</td>
          </tr>
          <tr>
            <td style="width: 104px;display: flex;">2023年：</td>
            <td>
              6月，举重博物馆主体工程完工<br/>
              11月7日，国家体育总局举摔柔运动管理中心、中国举重协会和东莞市人民政府共同签署《举重博物馆(筹)合作共建框架协议》，以做好举重博物馆筹建、管理和运营工作，提高石龙镇举重训练竞技水平。
            </td>
          </tr>
        </table>
        <img src="@/assets/images/MuseumAffairs05@2x.png" style="margin-top: 40px;width: 100%;" alt="">
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api";
  import {mixin} from '@/mixin/index.js';
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "A4",
    mixins : [mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        // 富文本内容
        content: ``,
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.getData()
      }
    },
    created() {
      this.getData()
    },
    methods:{
      async getData(val) {
        let params = {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "大事记",
          articleKey:'cms'
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await getSingle(params)
        rows[0].articleContent = this.updateImageUrl(rows[0].articleContent)
        this.content = rows[0].articleContent
      },
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .container{
    padding-bottom: 104px;
  }
  .wrap {
    width: 1210px;
    margin: 0 auto;
    overflow: hidden;

    >img:nth-of-type(1) {
      display: block;
      margin: 0 auto 48px;
    }

    p {
      font-family: Source Han Sans CN;
      font-size: 24px;
      color: #666666;
      line-height: 48px;

      span {
        color: #222;
      }
    }
  }

  table{
    font-family: Source Han Sans CN;
    font-size: 24px;
    color: #666666;
    line-height: 48px;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/components/MuseumAffairs/A4/A4.vue